import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Injector, Input } from '@angular/core';
import { RxOnInit } from '@examdojo/angular/util';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TopicLevel2TreeItem } from '../../model';
import { TopicsTreeMode } from '../../topics-tree-mode';
import { AssetTreeBadgeType } from '../asset-tree-toolbar';
import { TOPICS_TREE_BADGE_COMPONENTS, TopicsTreeBadgeComponents } from './topics-tree-badge-components';

@RxOnInit()
@UntilDestroy()
@Component({
  selector: 'exam-asset-tree-badge',
  templateUrl: './asset-tree-badge.component.html',
  styleUrls: ['./asset-tree-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
})
export class AssetTreeBadgeComponent {
  constructor(
    @Inject(TOPICS_TREE_BADGE_COMPONENTS)
    protected readonly badgeComponents: TopicsTreeBadgeComponents<TopicsTreeMode>,
    protected readonly injector: Injector,
  ) {}

  @Input({ required: true }) asset!: TopicLevel2TreeItem;

  @Input({ required: true }) badgeType!: AssetTreeBadgeType;
}
